import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-topbar-item',
  templateUrl: './topbar-item.component.html'
})
export class TopbarItemComponent implements OnInit {
  @ViewChild('content', { static: true }) content: ElementRef;
  @Input() link: string;
  @Input() icon: string;
  @Input() styleClass: string;

  constructor() { }

  ngOnInit() {
  }

}
